import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the MenuXxssPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-xxss',
  templateUrl: 'menu-xxss.html',
})
export class MenuXxssPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

  onBack(){
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-xxss/menu-xxss.ts